import React from "react"
import { shape } from "prop-types"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"
import styled from "@emotion/styled"
import { Truncate } from "../../helpers"

const propTypes = {
  data: shape().isRequired,
}

const StyledDescription = styled.p`
  font-size: 70%;
  @media ${props => props.theme.breakpoint.mobile} {
    font-size: 100% !important;
  }
  @media ${props => props.theme.breakpoint.laptop} {
    font-size: 80% !important;
  }
  @media ${props => props.theme.breakpoint.desktop} {
    font-size: 70% !important;
  }
  margin-bottom: 1.5vw;
`

const ProductDescription = ({ data }) => {
  return (
    <StyledDescription>
      {Truncate(documentToPlainTextString(data), 190)}
    </StyledDescription>
  )
}

ProductDescription.propTypes = propTypes

export default ProductDescription
